/** @file Constraints panel registration: IK constraints (the only constraint type in phase 1). */
import { rigPanel } from '../rigKit/rigPanel';
import { ConstraintsView } from './ConstraintsView';

/** Rig panel over ik.create / set / setKey / delete. */
export const panel = rigPanel('constraints', 'panels.constraints.title', ConstraintsView);
